/**
 * 소셜 로그인 팝업(`signInWithPopup`)이 실패가 아니라 유저의 취소로 끝났는지 — 실패 토스트를 띄우지 않을 오류(#2699).
 *
 * - `auth/popup-closed-by-user`: 팝업을 닫았다. Firebase 는 창이 닫혔는지 2초마다 보고, 닫힌 걸 본 뒤에도
 *   8초를 더 기다렸다가 이 오류로 끝낸다
 * - `auth/cancelled-popup-request`: 그 사이(약 8~10초)에 다시 눌러 새 팝업이 앞 요청을 취소했다. 연타도 같다
 */
export const isPopupCancelledByUser = (error: unknown): boolean => {
  if (typeof error !== 'object' || error === null || !('code' in error)) return false;
  return error.code === 'auth/popup-closed-by-user' || error.code === 'auth/cancelled-popup-request';
};
